import { render, staticRenderFns } from "./batchAction.vue?vue&type=template&id=64ee242f&scoped=true"
import script from "./batchAction.vue?vue&type=script&lang=js"
export * from "./batchAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee242f",
  null
  
)

export default component.exports